import { Button } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { Icon, Tooltip } from '@/shared/ui';

export type SpotlightButtonProps = {
  onOpen: () => void;
  className?: string;
  shortcut: string;
};

export const SpotlightButton: FC<SpotlightButtonProps> = ({ onOpen, className, shortcut }) => {
  const { t } = useTranslation(['common']);
  return (
    // Видимое у кнопки — значок и сочетание клавиш: название действия она показывает подсказкой,
    // иначе опознаётся только чтением с экрана
    <Tooltip tooltip={t('search')}>
      <Button
        aria-label={t('search')}
        variant={'ghost'}
        size={'sm'}
        className={cn('shrink-0', className)}
        onClick={onOpen}
      >
        <Icon type={'search'} width={20} />
        <span className="ml-2 text-muted-foreground hidden lg:inline">{shortcut}</span>
      </Button>
    </Tooltip>
  );
};
